import { useState, useEffect } from "react";
import {
  Box,
  InputBase,
  Typography,
  Button,
  Dialog,
  DialogContent,
  TextField,
} from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseSupplierOffer } from "./UseSupplierOffer";
import { useNavigate, useLocation } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import CustomPagination from "../../components/CustomPagination";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { deCapitalizeFirstLetter, toMoney } from "../../util/Utils";
import DeleteRow from "../../components/DeleteRow";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import CheckIcon from "@mui/icons-material/Check";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import OfferDetail from "./OfferDetail";
import YesOrNoDialoge from "../../components/YesOrNoDialoge";

export default function SupplierOffers() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const navigate = useNavigate();
  const { getOfferList, validate, cancelOffer, addOffer } = UseSupplierOffer();
  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC("shamsiLogdate", "Desc");
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [checkState, setCheckState] = useState({
    show: false,
    name: undefined,
  });
  const [showAdd, setShowAdd] = useState(false);
  const [open, setOpen] = useState({ show: false, id: undefined });
  const [supplierRes, setOfferRes] = useState();
  const [state, setState] = useState({
    offerID: false,
    productCount: undefined,
    description: undefined,
  });
  const [errorState, setErrorState] = useState({
    productCount: false,
  });
  function handleSearch(value) {
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    getOfferList(
      myPc,
      search,
      (supplieroffer) => {
        if (msGotoLast) {
          setMsGotoLast(false);
          goToLastPage(supplieroffer.pageCondition.totalPage);
          return;
        }
        setOfferRes(supplieroffer);
      },
      true
    );
  }, [myPc]);

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const newFunc = () => {
    return navigate("/supplieroffer/addOffer", {
      state: {
        myPc: myPc,
        search: search,
      },
    });
  };

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
      hide: true,
    },
    {
      field: "rowIndex",
      width: 80,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "productID",
      headerName: "کد محصول",
      width: 100,
      align: "center",
      headerAlign: "center",
      sortable: false,
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.productID}
          </Typography>
        );
      },
    },

    {
      field: "product",
      headerName: "محصول",
      width: 250,
      align: "center",
      headerAlign: "center",
      sortable: false,
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.product}
          </Typography>
        );
      },
    },
    {
      field: "supplier",
      headerName: "تامین کننده",
      width: 150,
      align: "center",
      headerAlign: "center",
      sortable: false,
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.supplier}
          </Typography>
        );
      },
    },
    {
      field: "productCount",
      headerName: "تعداد پیشنهاد",
      width: 100,
      align: "center",
      headerAlign: "center",
      sortable: false,
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.productCount
              ? toMoney(cellValues.row.productCount)
              : 0}
          </Typography>
        );
      },
    },
    {
      field: "requestCount",
      headerName: " درخواستی",
      width: 100,
      align: "center",
      headerAlign: "center",
      sortable: false,
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.requestCount
              ? toMoney(cellValues.row.productCount)
              : 0}
          </Typography>
        );
      },
    },
    {
      field: "shamsiLogdate",
      headerName: " تاریخ پیشنهاد",
      width: 120,
      align: "center",
      headerAlign: "center",
      sortable: false,
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ direction: "rtl" }}>
            {cellValues.row.shamsiLogdate}
          </Typography>
        );
      },
    },
    {
      field: "stateTitle",
      headerName: "وضعیت",
      width: 130,
      align: "center",
      sortable: false,
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.stateTitle}
          </Typography>
        );
      },
    },

    {
      field: "عملیات",
      sortable: false,
      width: 280,
      align: "center",
      headerAlign: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <Box sx={{ display: "flex", gap: 1 }}>
            <Button
              color="secondary"
              variant="outlined"
              onClick={() => {
                setOpen({ show: true, id: cellValues.row.id });
              }}
            >
              جزئیات
            </Button>
            <Button
              color="secondary"
              variant="contained"
              onClick={() => {
                setShowAdd(true);
                setState({
                  productID: cellValues.row.productID,
                  offerID: cellValues.row.id,
                  productCount: cellValues.row.productCount,
                  description: cellValues.row.description,
                });
              }}
            >
              ثبت درخواست
            </Button>
            <Button
              disabled={cellValues.row.state == 3 ? true : false}
              color="error"
              variant="contained"
              onClick={() => {
                setCheckState({
                  show: true,
                  name: "لغو درخواست",
                  offerID: cellValues.row.id,
                });
              }}
            >
              لغو درخواست
            </Button>
          </Box>
        );
      },
    },
    {
      field: "search",
      width: 200,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              value={searchState}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                if (evt.target.value == "") {
                  handleSearch("");
                }
                setSearchState(evt.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(searchState);
                }
              }}
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "بازرگانی",
        childs: [{ name: msActiveMenu.pageTitle, url: "/supplieroffer" }],
      }}
    >
      <Dialog
        PaperProps={{
          elevation: 1,
        }}
        fullWidth
        maxWidth="xs"
        open={showAdd}
        onClose={() => setShowAdd(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 3,
            }}
          >
            <TextField
              error={errorState.productCount}
              sx={{ input: { textAlign: "center" }, width: "50%" }}
              label="تعداد درخواستی"
              value={state.productCount ? state.productCount : ""}
              onChange={(evt) => {
                setState({ ...state, productCount: evt.target.value });
              }}
              size="small"
              type="number"
              variant="outlined"
            />
            <TextField
              label="توضیحات"
              multiline
              rows={3}
              fullWidth
              value={state.description ? state.description : ""}
              onChange={(evt) => {
                setState({ ...state, description: evt.target.value });
              }}
              size="small"
              variant="outlined"
            />
            <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
              <Button
                onClick={() => {
                  if (validate(state, setErrorState) == 200) {
                    setProgress(true);
                    addOffer(state, (call) => {
                      setShowAdd(false);
                      getOfferList(
                        myPc,
                        search,
                        (supplieroffer) => {
                          setOfferRes(supplieroffer);
                        },
                        false
                      );
                    });
                  }
                }}
                variant="contained"
              >
                ثبت
              </Button>
              <Button onClick={() => setShowAdd(false)} variant="outlined">
                انصراف
              </Button>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
      {supplierRes ? (
        <DataGrid
          disableVirtualization
          className="ltr-grid"
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          pageSize={supplierRes.pageCondition.pageCount}
          rows={supplierRes.items}
          paginationMode="server"
          page={supplierRes.pageCondition.page - 1}
          onPageChange={(page) => {
            updatePage(page + 1);
          }}
          rowCount={supplierRes.pageCondition.totalItemCount}
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              scrollTo: myPc.scrollTo,
              newFunc: newFunc,
              nofab: true,
              isLtr: true,
              rowCount: supplierRes.pageCondition.totalItemCount,
            },
          }}
          sx={{
            "& .MuiDataGrid-cell:focus": {
              outline: "none",
            },
            "&  .MuiDataGrid-columnHeader:focus-within": {
              outline: "none",
            },
            "&  .MuiDataGrid-cell:focus-within ": {
              outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
            },
            "& .muirtl-hnxuso-MuiDataGrid-root .MuiDataGrid-cell:focus-within":
              {
                outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
              },
            "& .MuiDataGrid-cell:hover": {
              color: "primary.main",
            },
            "& .MuiDataGrid-virtualScrollerRenderZone": {
              width: "100% !important",
            },
            "& .green": {
              backgroundColor: "#56ff004f !important",
            },
            "& .red": {
              backgroundColor: "#ff9c9c !important",
            },
          }}
          getRowClassName={(params) => {
            if (params.row.state == 2) {
              return "green";
            }
            if (params.row.state == 3) {
              return "red";
            }
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: deCapitalizeFirstLetter(myPc.sortColumn),
                  sort: deCapitalizeFirstLetter(myPc.sortOrder),
                },
              ],
            },
            pagination: {
              page: myPc.page,
            },
          }}
          onSortModelChange={(model) => {
            updateSort(model[0].field, model[0].sort == "asc" ? "asc" : "desc");
          }}
          sortingOrder={["desc", "asc"]}
          sortingMode="server"
        />
      ) : (
        <ProgressCom></ProgressCom>
      )}
      {open.show && (
        <OfferDetail setOpen={setOpen} open={open} offerID={open.id} />
      )}
      <YesOrNoDialoge
        checkState={checkState}
        setCheckState={setCheckState}
        callback={() => {
          setProgress(true);
          // return;
          let state = {
            offerID: checkState.offerID,
          };
          cancelOffer(state, () => {
            getOfferList(
              myPc,
              search,
              (supplieroffer) => {
                setOfferRes(supplieroffer);
              },
              false
            );
          });
        }}
      />
    </Detail>
  );
}
